import React from "react";
import {Button, Card, Container, Form, Grid, Icon, Loader, Table, TextArea} from "semantic-ui-react";
import {connect} from "react-redux";
import {Editor, EditorState, convertToRaw, convertFromRaw, RichUtils} from 'draft-js';
import * as StaticActions from "../actions/StaticActions";

class AdminPage extends React.Component {

    state = {
        editing: null,
        editingText: "",
        editorState: EditorState.createEmpty(),
    };

    componentDidMount() {

        this.props.loadStaticTexts();

        this.onChange = (editorState) => this.setState({editorState});
        this.handleKeyCommand = this.handleKeyCommand.bind(this);

    }

    componentWillReceiveProps(props) {

        let {texts} = props;
        let newTexts = [];
        if (texts) {
            for (let text of Object.values(texts)){
                newTexts.push({
                    ...text,
                    editorState: text.blocks && EditorState.createWithContent(convertFromRaw(text.blocks)) || EditorState.createEmpty(),
                    // editorState: text.text && text.id === "contact" && EditorState.createWithContent(convertFromRaw(text.text)),
                })
            }
        }
        this.setState({
            texts: newTexts,
        })

    }

    handleKeyCommand(command, editorState) {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            this.onChange(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    edit(text) {
        this.setState({
            editing: text.id,
            // editingText: text.text,
            editorState: text.editorState,
        })
    }

    // update(id, editorState) {
    //
    //     let texts = this.state.texts;
    //     for (let i = 0; i < texts.length; i ++){
    //         if (texts[i].id === id) {
    //             texts[i].editorState = editorState;
    //             this.setState({texts});
    //             return;
    //         }
    //     }
    // }

    save() {

        this.props.save({
            id: this.state.editing,
            blocks: convertToRaw(this.state.editorState.getCurrentContent())
        });

        this.setState({editing: null});

    }

    render() {

        const {fetching, saving} = this.props;
        const {editing, texts} = this.state;

        return <div className="page-container">
            <br/><br/>
            <Container>
                {fetching ? <Loader active/> : <div>
                    {texts && texts.map(text => {
                        return <Card key={texts.id} fluid>
                            <Card.Content>
                                <Card.Header>{text.id}</Card.Header>

                                {text.editorState && <Editor editorState={editing === text.id ? this.state.editorState : text.editorState} onChange={this.onChange} readOnly={editing !== text.id} handleKeyCommand={this.handleKeyCommand}/>}
                                {/*{editing === text.id ? <Card.Description>*/}
                                    {/*<Form>*/}
                                        {/*<Editor editorState={this.state.editorState} onChange={(editorState) => this.setState({editorState})} />*/}

                                        {/*/!*<TextArea value={editingText} onChange={(e) => this.setState({editingText: e.target.value})} />*!/*/}
                                    {/*</Form>*/}
                                    {/*</Card.Description> :*/}
                                    {/*<Card.Description>*/}
                                        {/*/!*{text.text}*!/*/}
                                    {/*</Card.Description>*/}
                                {/*}*/}


                            </Card.Content>
                            <Card.Content extra>
                                {saving ? <Loader active/> :
                                    editing === text.id ?
                                        <Button.Group>
                                            <Button basic color="black"
                                                    onClick={() => this.setState({editing: null})}>Cancel</Button>
                                            <Button basic color="blue" onClick={() => this.save()}>Save</Button>
                                        </Button.Group>
                                        :
                                        <Button basic icon="edit" onClick={() => this.edit(text)}/>
                                }
                            </Card.Content>
                        </Card>

                    })}
                </div>
                }
            </Container>
        </div>
    }
}


export default connect(state => ({
    fetching: state.staticTexts.fetching,
    saving: state.staticTexts.saving,
    texts: state.staticTexts.items,
}), dispatch => ({
    loadStaticTexts: () => dispatch(StaticActions.fetchStaticTextsIfNecessary()),
    save: (text) => dispatch(StaticActions.save(text)),
}))(AdminPage)


// WEBPACK FOOTER //
// ./src/homepage/AdminPage.js